import {ReelsEvents} from '@gongxigames/framework/slot/modules/reels/ReelsEvents';
import {ReelsModule} from '@gongxigames/framework/slot/modules/reels/ReelsModule';
import {FirecatcherConstants} from '@gongxigames/framework/slot/modules/reels/FirecatcherConstants';
import {FirecatcherReelsModule} from '@gongxigames/framework/slot/modules/reels/FirecatcherReelsModule';
import {ReelsSpinningState} from '@gongxigames/framework/slot/modules/reels/states/ReelsSpinningState';
import {Timer} from '@gongxigames/framework/core';

export class FirecatcherReelsSpinningState extends ReelsSpinningState {

    public onEnterState(): void {
        this.module.resetParameters();
        this.startReels();

        // this.module.soundPlayer.duckMusic();

        const prizeCount: number = this.module.prizeCount;
        const REELS_AMOUNT: number = this.view.reelConstants.REELS_AMOUNT;
        const isLastSpin: boolean = prizeCount === REELS_AMOUNT - 1;
        const isLastTry: boolean = this.module.respinsCount === 1;
        const lastTryAdditionalTime: number = (isLastTry && isLastSpin) ? FirecatcherConstants.LAST_TRY_ADDITIONAL_TIME : 0;
        const lastRespinAdditionalTime: number = isLastSpin ? FirecatcherConstants.LAST_RESPIN_ADDITIONAL_TIME : 0;
        const initialDelay: number = FirecatcherConstants.PRIZE_COUNT_STOP_TIMING_MAP[prizeCount].initialDelay;
        const stopTimerDuration = this.module.isTurboSpin() ? 0 :
            initialDelay -
            this.view.reelConstants.REEL_BOUNCE_TIME +
            lastTryAdditionalTime +
            lastRespinAdditionalTime;

        this._expectingResponse = false;
        this._stopTimer = new Timer(this.onBeforeStopTimer.bind(this), stopTimerDuration, true);
        this.module.updateManager.add(this._stopTimer);

        this.view.showAllSymbols();

        this.module.eventManager.emit(ReelsEvents.REELS_SPINNING_STARTED);
    }

    protected tryInitializeStoppingState(): void {
        if (this.module.isReelsCanBeStopped) {
            this.module.gotoState(ReelsModule.RESPIN_STOPPING_STATE);
        } else {
            this._expectingResponse = true;
        }
    }

    protected onTryinToStopSpinningWithSpinButton(): void {
        this.getOutStopPositionsFromResponse();
        this.module.gotoState(ReelsModule.RESPIN_QUICKSTOP_STATE);
    }

    protected get module(): FirecatcherReelsModule {
        return this._module as FirecatcherReelsModule;
    }
}
